<template>
    <div class="vue-occasions-overview">
        <slot v-if="showPlaceholders"></slot>

        <div class="row" v-if="!showPlaceholders">
            <div class="col-xl-3 col-lg-12 region-filters">
                <div class="row">
                    <template v-if="hasFilters === true">
                        <div class="col-12">
                            <p class="mb-4 filter-title d-flex justify-content-between align-items-center"><strong>Filter</strong> <span class="reset-filters" @click="handleResetFilters">reset filters</span></p>
                        </div>

                        <div class="vue-filter-wrapper filter col-12" v-if="hasGarage === true">
                          <h4>Vestiging</h4> <p>{{ selectedGarage.value }}</p>
                        </div>

                        <occasion-filter-group title="Merk en model" :show-open="true">
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Merk" :options="filters.field_merk" filter-key="field_merk"></occasion-dropdown-filter>
                            <occasion-dropdown-filter v-if="showModelDropdown" :event-bus="eventBus" label="name" placeholder="Model" :options="filters.field_model" filter-key="field_model"></occasion-dropdown-filter>
                        </occasion-filter-group>

                        <occasion-filter-group v-if="filters.field_bouwjaar.min !== filters.field_bouwjaar.max" title="Bouwjaar">
                            <occasion-dropdown-range-filter
                                :event-bus="eventBus"
                                :step.number="1"
                                :min="filters.field_bouwjaar.min"
                                :max="filters.field_bouwjaar.max"
                                filter-key="field_bouwjaar"
                                placeholder="Bouwjaar van"
                                :reverse-range="true"
                            ></occasion-dropdown-range-filter>
                        </occasion-filter-group>

                        <occasion-filter-group v-if="filters.field_kilometerstand.min !== filters.field_kilometerstand.max" title="Kilometerstand">
                            <occasion-dropdown-range-filter
                                :event-bus="eventBus"
                                :step.number="10000"
                                :min="filters.field_kilometerstand.min"
                                :max="filters.field_kilometerstand.max"
                                placeholder="Km.stand van"
                                suffix=" km"
                                filter-key="field_kilometerstand"
                            ></occasion-dropdown-range-filter>
                        </occasion-filter-group>

                        <occasion-filter-group v-if="filters.field_prijs.min !== filters.field_prijs.max" title="Prijs">
                            <occasion-dropdown-range-filter
                                :event-bus="eventBus"
                                :step.number="5000"
                                :min="filters.field_prijs.min"
                                :max="filters.field_prijs.max"
                                prefix="€ "
                                placeholder="Prijs van"
                                filter-key="field_prijs"
                            ></occasion-dropdown-range-filter>
                        </occasion-filter-group>

                        <occasion-filter-group v-if="hasOtherOptions" title="Overige opties">
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Brandstof" :options="filters.field_brandstof" filter-key="field_brandstof"></occasion-dropdown-filter>
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Transmissie" :options="filters.field_transmissie" filter-key="field_transmissie"></occasion-dropdown-filter>
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Carrosserie" :options="filters.field_carrosserie" filter-key="field_carrosserie"></occasion-dropdown-filter>
                        </occasion-filter-group>

                        <occasion-filter-group title="Kleur" v-if="filters.field_basiskleur.length > 1">
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Kleur" :options="filters.field_basiskleur" filter-key="field_basiskleur"></occasion-dropdown-filter>
                        </occasion-filter-group>

                        <occasion-filter-group title="Aantal deuren" v-if="filters.field_aantal_deuren.length > 1">
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Aantal deuren" :options="filters.field_aantal_deuren" filter-key="field_aantal_deuren"></occasion-dropdown-filter>
                        </occasion-filter-group>

                        <occasion-filter-group title="Aantal cilinders" v-if="filters.field_aantal_cilinders.length > 1">
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Aantal cilinders" :options="filters.field_aantal_cilinders" filter-key="field_aantal_cilinders"></occasion-dropdown-filter>
                        </occasion-filter-group>

                        <occasion-filter-group title="Garage" v-if="filters.field_garage.length > 1">
                            <occasion-dropdown-filter :event-bus="eventBus" placeholder="Garage" :options="filters.field_garage" filter-key="field_garage"></occasion-dropdown-filter>
                        </occasion-filter-group>
                    </template>
                </div>
            </div>

            <div class="col-xl-9 col-lg-12 mt-3 mt-xl-0">
                <div class="row mb-4 occasion-metas">
                    <div class="col-md-6">
                        <p><strong>{{ meta.items }} resultaten</strong></p>
                    </div>
                    <div class="col-md-6 text-right occasion-sort d-flex align-items-center justify-content-end">
                        <p>Sorteer op</p>

                        <select class="form-control ml-3" id="sort-select" v-model="sort">
                            <option value="field_merk-ASC">Merk oplopend</option>
                            <option value="field_merk-DESC">Merk aflopend</option>
                            <option value="created_at-DESC">Laatst geplaatst aflopend</option>
                            <option value="created_at-ASC">Laatst geplaatst oplopend</option>
                            <option value="field_prijs-DESC">Prijs aflopend</option>
                            <option value="field_prijs-ASC">Prijs oplopend</option>
                            <option value="field_bouwjaar-ASC">Bouwjaar oplopend</option>
                            <option value="field_bouwjaar-DESC">Bouwjaar aflopend</option>
                            <option value="field_kilometerstand-ASC">Kilometerstand oplopend</option>
                            <option value="field_kilometerstand-DESC">Kilometerstand aflopend</option>
                        </select>
                    </div>
                </div>
                <template v-if="hasItems === true">
                    <div class="occasion-list-wrapper" :class="{'loading-occasions': isLoading}">
                        <occasion-list-item v-for="(item, index) in items" :key="`occasion-${index}`" :item="item"></occasion-list-item>

                        <loader v-if="infiniteScrollActive === true" @loader-visibility="handleLoaderVisibility"></loader>
                    </div>
                </template>

                <template v-if="hasItems === false && isLoading === false">
                    <h3>Geen resultaten</h3>
                    <p>Geen resultaten, pas de filters aan.</p>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import occasionOverviewMixin from "../mixins/occasionOverviewMixin";

export default {
    name: "OccasionOverview",

    mixins: [occasionOverviewMixin],

    data() {
        return {
            isLoading: false,
            infiniteScrollActive: false,
            showPlaceholders: true,
        }
    },

    computed: {
        hasItems() {
            return !_.isEmpty(this.items);
        },

        hasOtherOptions() {
            return this.filters.field_brandstof.length > 1
                && this.filters.field_transmissie.length > 1
                && this.filters.field_carrosserie.length > 1
        },

        hasLocalStorage() {
            return !_.isEmpty(localStorage.getItem('appliedFilters'));
        }
    },

    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        if(!lodash.isNil(urlParams.get('vestiging'))) {
          const filterValue = [{
            "key" : "field_garage",
            "value" : urlParams.get('vestiging'),
            "type": "dropdown"
          }];
          localStorage.setItem('appliedFilters', JSON.stringify(filterValue));
        }

        if (this.hasLocalStorage === true) {
            this.appliedFilters = JSON.parse(localStorage.getItem('appliedFilters'));
        }

        if (!lodash.isNil(localStorage.getItem('occasionOverviewSort'))) {
            this.sort = localStorage.getItem('occasionOverviewSort');
        }

        this.fetchData();
    },

    methods: {
        fetchData() {
            this.isLoading = true;

            axios.get('/api/occasions', {
                params: {
                    filters: JSON.stringify(this.appliedFilters),
                    page: this.page,
                    sort: this.sort
                }
            }).then(response => {
                if (response.data.meta.currentPage === 1) {
                    this.items = response.data.data;
                    this.filters = response.data.filters;
                }

                if (response.data.meta.currentPage >= 2) {
                    this.items = this.$set(this, 'items', [...this.items, ...response.data.data]);
                }

                this.meta = response.data.meta;
                this.infiniteScrollActive = !lodash.isNil(response.data.meta.nextPage);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.isLoading = false;
                this.showPlaceholders = false;

                if (this.hasLocalStorage === true) {
                    this.handleLocalStorageFilters();
                }
            });
        },

        handleLoaderVisibility(payload) {
            if (!payload.visible || this.isLoading === true) {
                return;
            }

            this.page++;
            this.fetchData();
        },

        handleLocalStorageFilters() {
            _.forEach(this.appliedFilters, (appliedFilter) => {
                if (appliedFilter.type === 'range') {
                    let filter = this.filters[appliedFilter.key];

                    this.$set(filter, 'populatedValue', [appliedFilter.min, appliedFilter.max]);
                }

                if (appliedFilter.type === 'dropdown') {
                    let filter = this.filters[appliedFilter.key];

                    this.$set(filter, 'populatedValue', ...[appliedFilter.value]);
                }
            });
        },

        handleResetFilters() {
            this.eventBus.$emit('reset-filters');
            this.appliedFilters = [];

            if(!lodash.isNil(window.defaultGarage)) {
              localStorage.setItem("appliedFilters", JSON.stringify(window.defaultGarage));
              this.appliedFilters = JSON.parse(localStorage.getItem('appliedFilters'));
            }

            this.page = 1;
            this.fetchData();
        }
    },

    watch: {
        sort(newValue) {
            localStorage.setItem('occasionOverviewSort', newValue);
            this.page = 1;
            this.fetchData();
        }
    }
}
</script>
